import { render, staticRenderFns } from "./AutoNotifications.vue?vue&type=template&id=70452f3a&"
import script from "./AutoNotifications.vue?vue&type=script&lang=js&"
export * from "./AutoNotifications.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports